import api from 'services/sale/client'

export const handleAddEquipment = async (values: any) => {
  let res = await api.addEquipment(values)

  return res?.data?.success
}
